import Users from './containers/UsersContainer';

export default Users;
